/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { themeToken } from '../../utils/cpds-utils';

const CpdsRatingsScore = styled.div.attrs({
  className: 'cpds-meta-roman-medium-book-10',
  'data-cy': 'cpdsratingsscore',
})`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 4px;
  gap: 10px;
  width: 32px;
  height: 24px;
  border-radius: 4px;
`;

const CpdsRatingsSummary = styled.div.attrs({
  'data-cy': 'cpdsratingssummary',
})`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const CpdsRatingsText = styled.p.attrs({
  className: 'cpds-meta-roman-medium-book-10',
  'data-cy': 'cpdsratingstext',
})``;

const CpdsRatingsReviewText = styled.p.attrs({
  className: 'cpds-meta-roman-book-10',
  'data-cy': 'cpdsratingsreviewtext',
})``;

const ratingStyles = (token) => ({
  okay: {
    score: token?.ratings_grey_background_rating_score_text_color,
    text: token?.ratings_grey_background_text_color,
    bg: token?.ratings_grey_background_color,
  },
  good: {
    score: token?.ratings_grey_background_rating_score_text_color,
    text: token?.ratings_grey_background_text_color,
    bg: token?.ratings_grey_background_color,
  },
  very_good: {
    score: token?.ratings_green_background_rating_score_text_color,
    text: token?.ratings_green_background_text_color,
    bg: token?.ratings_green_background_color,
  },
  excellent: {
    score: token?.ratings_green_background_rating_score_text_color,
    text: token?.ratings_green_background_text_color,
    bg: token?.ratings_green_background_color,
  },
  wonderful: {
    score: token?.ratings_green_background_rating_score_text_color,
    text: token?.ratings_green_background_text_color,
    bg: token?.ratings_green_background_color,
  },
  exceptional: {
    score: token?.ratings_green_background_rating_score_text_color,
    text: token?.ratings_green_background_text_color,
    bg: token?.ratings_green_background_color,
  },
});

const CpdsRatingsWrapper = styled.div.attrs({
  'data-cy': 'cpdsratingswrapper',
})`
  ${({
    theme: {
      styles: { cpds },
    },
    level = 'okay',
    ...props
  }) => {
    const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);

    const ratingStyle = ratingStyles(token)?.[level];

    return css`
      display: flex;
      gap: 8px;
      ${CpdsRatingsScore} {
        background-color: ${ratingStyle.bg};
        color: ${ratingStyle.score};
      }
      ${CpdsRatingsText},
      ${CpdsRatingsReviewText} {
        color: ${ratingStyle.text};
      }
      ${(props) => props?.styleOverrides};
    `;
  }}
`;

export { CpdsRatingsWrapper, CpdsRatingsScore, CpdsRatingsSummary, CpdsRatingsReviewText, CpdsRatingsText };
